import AppSetting from './AppSetting';
import Ressource from '../modeles/Ressource';

const contextActualite = require.context('../images/actualite', false, /\.(png|jpe?g|gif|webp|svg)$/i);
const contextEvenement = require.context('../images/evenement', false, /\.(png|jpe?g|gif|webp|svg)$/i);
const contextPratique = require.context('../images/pratique', false, /\.(png|jpe?g|gif|webp|svg)$/i);
const contextNavigation = require.context('../images/navigation', false, /\.(png|jpe?g|gif|webp|svg)$/i);
const contextFormation = require.context('../images/formation', false, /\.(png|jpe?g|gif|webp|svg)$/i);
const contextEmploi = require.context('../images/emploi', false, /\.(png|jpe?g|gif|webp|svg)$/i);
const contextFlashInfo = require.context('../images/flashInfo', false, /\.(png|jpe?g|gif|webp|svg)$/i);
const contextGaleries = require.context('../images/galeries', false, /\.(png|jpe?g|gif|webp|svg)$/i);
const contextGeneral = require.context('../images/general', false, /\.(png|jpe?g|gif|webp|svg)$/i);

const contextesParCategorie = {
  actualite: contextActualite,
  actualites: contextActualite,
  evenement: contextEvenement,
  evenements: contextEvenement,
  pratique: contextPratique,
  pratiques: contextPratique,
  navigation: contextNavigation,
  accueil: contextNavigation,
  formation: contextFormation,
  formations: contextFormation,
  emploi: contextEmploi,
  flashinfo: contextFlashInfo,
  flashInfo: contextFlashInfo,
  galerie: contextGaleries,
  galeries: contextGaleries,
  annonce: contextGeneral,
  annonces: contextGeneral,
  presentation: contextGeneral,
  presentations: contextGeneral,
  general: contextGeneral,
};

const normaliserCategorie = (categorie) => String(categorie || '').trim().toLowerCase();

// webpack peut retourner un module ES { default: 'url' } ou une string directe
const resoudreModule = (mod: any): string => {
  if (typeof mod === 'string') return mod;
  if (mod && typeof mod === 'object' && mod.default) return String(mod.default);
  return '';
};

export const obtenirImagesLocalesParCategorie = (categorie) => {
  const ctx = contextesParCategorie[normaliserCategorie(categorie)];
  if (!ctx) return [];
  try {
    return ctx.keys().map((key) => resoudreModule(ctx(key))).filter(Boolean);
  } catch {
    return [];
  }
};

export const obtenirImageDepuisRessource = (cheminFichier, categorie, fallback = '', index = 0) => {
  const chemin = String(cheminFichier || '').trim().replace(/\\/g, '/');

  if (!chemin) {
    if (fallback) return fallback;
    // Aucun chemin fourni → utiliser une image locale de la catégorie
    const ctx = contextesParCategorie[normaliserCategorie(categorie)];
    if (ctx) {
      const keys = ctx.keys();
      if (keys.length > 0) return resoudreModule(ctx(keys[index % keys.length]));
    }
    return '';
  }

  // URL absolue retournée par le backend → retourner directement
  if (/^https?:\/\//i.test(chemin)) return chemin;

  // Chemin relatif → construire l'URL complète depuis le serveur d'images
  const cheminNormalise = chemin.startsWith('/') ? chemin : `/${chemin}`;
  const url = `${AppSetting.UrlBase}${cheminNormalise}`;
  console.debug('[obtenirImageDepuisRessource]', { cheminFichier, url });
  return url;
};

// Résout directement l'URL de l'image depuis les champs image/cheminFichier de la Ressource
export const obtenirUrlImage = (ressource: Ressource): string => {
  const chemin = String(ressource.image || ressource.cheminFichier || '').trim().replace(/\\/g, '/');
  if (!chemin) return '';
  if (/^https?:\/\//i.test(chemin)) return chemin;
  const cheminNormalise = chemin.startsWith('/') ? chemin : `/${chemin}`;
  return `${AppSetting.UrlBase}${cheminNormalise}`;
};
